<template>
  <div>
    <SiteHero
      image="/media/aukcje-hero.webp"
      eyebrow="Portal aukcyjny"
      title="Aukcje"
      lead="Portal daje Ci wgląd w pojazdy wystawiane codziennie w japońskich domach aukcyjnych."
      scroll-to="jak-korzystac"
    />

    <!-- The auction search: the app's own widget, on the band the WordPress
         page used to fill with an <iframe>. -->
    <section class="site_container search_band_wrap">
      <div class="search_band">
        <div class="site_embed site_embed--searchbar">
          <SearchWidget />
        </div>
      </div>
    </section>

    <section id="jak-korzystac" class="site_section">
      <div class="site_container site_split how">
        <div>
          <p class="site_eyebrow">Jak to działa?</p>
          <h2 class="how_title">Jak korzystać z portalu aukcyjnego?</h2>
          <p class="how_lead">
            Lista znajdująca się na naszej stronie jest stale odświeżana. Filtry pozwalają
            zawęzić wyniki według marki, modelu, rocznika, przebiegu czy oceny stanu
            technicznego.
          </p>
          <div class="site_card">
            <h4 class="how_card_title">
              Każdy egzemplarz otrzymuje notę inspektora, co pozwala wstępnie ocenić
              kondycję jeszcze przed licytacją.
            </h4>
            <p>
              Jeżeli któraś pozycja przykuje Twoją uwagę, wyślij do nas zapytanie –
              sprawdzimy raport, dokładnie wyliczymy całkowity koszt sprowadzenia do Polski
              i ustalimy maksymalny budżet do licytacji.
            </p>
          </div>
        </div>

        <figure>
          <img
            src="/media/aukcje-inspekcja.webp"
            width="950"
            height="713"
            alt="Inspekcja samochodu przed licytacją"
            loading="lazy"
          />
        </figure>
      </div>
    </section>
  </div>
</template>

<script>
import pageHead from '@/mixins/pageHead'
import { pageSchema } from '@/utils/schema'
import SiteHero from '@/components/SiteHero.vue'
import SearchWidget from '@/views/Iframe.vue'

export default {
  name: 'AukcjePage',
  components: { SiteHero, SearchWidget },
  mixins: [pageHead],

  pageHead: {
    title: 'Aukcje - Japonia Cars',
    description:
      'Portal aukcyjny Japonia Cars — wgląd w pojazdy wystawiane codziennie w japońskich domach aukcyjnych.',
    schema: pageSchema({
      path: '/aukcje/',
      name: 'Aukcje',
      image: '/media/aukcje-inspekcja.webp',
      breadcrumbs: [{ name: 'Aukcje' }],
      published: '2026-05-12T05:53:19+00:00',
      modified: '2026-07-16T11:42:25+00:00',
    }),
  },
}
</script>

<style scoped>
.search_band_wrap {
  padding-top: 80px;
}

.search_band {
  padding: 16px;
  border-radius: var(--radius);
  background: #161616 url('/media/aukcje-tlo.webp') center / cover no-repeat;
}

/* The copy column is a little wider than the photo, as on the live site. */
.how {
  grid-template-columns: 706fr 572fr;
}

.how_title {
  margin: 15px 0 22.5px;
}

.how_lead {
  margin-bottom: 32px;
}

.how_card_title {
  margin-bottom: 11px;
}

/* The photo fills the height of the copy column next to it. */
.how figure {
  height: 100%;
}

.how figure img {
  width: 100%;
  height: 100%;
  border-radius: var(--radius);
  object-fit: cover;
}

@media (max-width: 1024px) {
  .how {
    grid-template-columns: 1fr;
  }
}
</style>
